// extracted by mini-css-extract-plugin
export default {"main":"page_main__p7Yzg","mask":"page_mask__VwpUO","body":"page_body__J-yBu"};